// extracted by mini-css-extract-plugin
export default {"ContainerFluid":"App_ContainerFluid__If2ri","ContentWrapper":"App_ContentWrapper__htxdG"};